import { Booking } from "interfaces/booking";
import { RNParams } from "./RNParams";
import { checkIn } from "services/SauceService";
import { NavigateFunction } from "react-router-dom";

export const restaurantCheckin = async (
  booking: Booking,
  navigate: NavigateFunction
) => {
  const shouldUseNewCheckinFlow =
    window.location.href.includes("localhost") ||
    window.location.href.includes("staging");
  const shouldUseNativeCheckin =
    window.ReactNativeWebView && RNParams.isNativeCheckinEnabled();
  if (shouldUseNativeCheckin && shouldUseNewCheckinFlow) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "collab_checkin",
        bookingId: booking.bookingId,
      })
    );
  } else if (shouldUseNewCheckinFlow) {
    navigate("/checkin-location", {
      state: { bookingId: booking.bookingId },
    });
  } else {
    // original flow
    await checkIn({
      bookingId: booking.bookingId,
    });
    navigate(`/welcome/${booking.bookingId}`);
  }
};
